import { useState } from "react";
import {
  Autocomplete,
  Button,
  DatePicker,
  Grid,
  TextField,
} from "../../../../components";
import {
  CaixaService,
  ContasPagarService,
  SessionService,
  notification,
} from "../../../../services";
import { formatDate, responseErros } from "../../../../utils";
import { InputErros, selecaoTitulosLote } from "../../../../helpers";
import ResumoTotalContas from "./resumo-total-contas.component";
import RenegociacaoTitulosDialog from "./renegociacao-titulos-dialog.component";
import {
  montaListaContasABaixar,
  montaListaRenegociacoes,
} from "../listContaPagar";
import listaContaPagarValidator from "../middlewares/list-conta-pagar.validator";
import { useImportContext } from "../../../../contexts/import.context";

const RenegociacaoTitulos = ({
  renderRenegociacaoTitulos,
  setRenderRenegociacaoTitulos,
  renegociacaoTitulos,
  setRenegociacaoTitulos,
  calculaTotalAPagar,
  buscaContasPagar,
  listaCondicoesPagamento,
  listaContasPagar,
  setListaContasPagar,
  listaPessoas,
  totalAPagar,
  retornoTopo,
  setLoading,
  setLinhasSelecionadas,
  setTotalAPagar,
  listaMeiosPagamento,
}) => {
  const contasPagarService = new ContasPagarService();
  const caixaService = new CaixaService();
  const sessionService = new SessionService();
  const { openCollapse } = useImportContext();
  const [meioPagamento, setMeioPagamento] = useState(null);
  const [condicaoPagamento, setCondicaoPagamento] = useState(null);
  const [listaMeiosCondicao, setListaMeiosCondicao] = useState([]);
  const [listaRenegociacoes, setListaRenegociacoes] = useState([]);
  const [recebedoresIguais, setRecebedoresIguais] = useState(false);
  const [recebedorList, setRecebedorList] = useState([]);
  const [pessoaId, setPessoaId] = useState(null);
  const [openDialogRenegociacao, setOpenDialogRenegociacao] = useState(false);
  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);
  const insertUserId = sessionService.getUsuario().id;

  const cadastrarCaixa = async (bancoCaixaId) => {
    const body = {
      data: new Date(),
      bancoCaixaId,
      aberto: true,
    };
    const result = await caixaService.cadastrar(body);
    if (result.isAxiosError) {
      responseErros(result);
      return false;
    }
    return true;
  };

  const handleSubmit = async (event, listaRenegociacoes) => {
    event.preventDefault();
    setLoading(true);
    const body = listaRenegociacoes.map((conta) => {
      return { ...conta, pessoaId };
    });
    if (!listaContasPagar.length) return erroBaixa();
    const caixaCadastrado = await cadastrarCaixa(meioPagamento?.bancoCaixaId);
    if (!caixaCadastrado) {
      return;
    }
    if (body?.length) {
      listaContaPagarValidator
        .validate(body, { abortEarly: false })
        .then(async () => {
          const res = await contasPagarService.cadastrarLista(body);
          setLoading(false);
          if (!res.isAxiosError) {
            salvarContasPagar();
          } else {
            responseErros(res);
          }
        })
        .catch((err) => {
          sairRenegociacaoTitulos();
          inputErros.set(err);
        });
    }
  };

  const salvarContasPagar = async () => {
    const listaContasBaixaLote = montaListaContasABaixar(
      listaContasPagar,
      meioPagamento,
      renegociacaoTitulos,
      true,
    );
    if (listaContasPagar?.length) {
      listaContaPagarValidator
        .validate(listaContasBaixaLote, { abortEarly: false })
        .then(async () => {
          const res = await contasPagarService.baixaEmLote(
            listaContasBaixaLote,
          );
          if (!res.isAxiosError) {
            sairRenegociacaoTitulos();
            buscaContasPagar();
            return notification.sucessoGenericos(
              "Renegociação realizada com sucesso!",
            );
          } else {
            responseErros(res);
          }
        })
        .catch((err) => {
          sairRenegociacaoTitulos();
          inputErros.set(err);
        });
    } else {
      erroBaixa();
    }
  };

  const handleOpenRenegociacao = () => {
    if (!listaContasPagar.length) return erroBaixa();
    if (listaContasPagar.length > selecaoTitulosLote.limiteTitulos) {
      return notification.alertaGenericos(
        selecaoTitulosLote.mensagemLimite(listaContasPagar.length),
      );
    }
    const body = montaListaRenegociacoes(
      listaContasPagar,
      renegociacaoTitulos,
      meioPagamento,
      condicaoPagamento,
      totalAPagar,
      insertUserId,
    );
    if (body.recebedores?.length) {
      const recebedoresIguais = body.recebedores.every((id) => {
        return id === body.recebedores[0];
      });
      if (!recebedoresIguais) {
        const recebedoresList = listaPessoas.filter((pessoa) =>
          body.recebedores.includes(pessoa.id),
        );
        setRecebedorList(recebedoresList);
      } else {
        setRecebedorList(listaPessoas);
        setPessoaId(body.recebedores[0]);
      }
      setRecebedoresIguais(recebedoresIguais);
    }
    setListaRenegociacoes(body.lista);
    setOpenDialogRenegociacao(true);
  };

  function erroBaixa() {
    sairRenegociacaoTitulos();
    return notification.alertaGenericos(
      "Selecione no mínimo uma conta a baixar",
    );
  }

  function sairRenegociacaoTitulos() {
    setLinhasSelecionadas([]);
    setTotalAPagar({
      multa: 0,
      juros: 0,
      subtotal: 0,
      receber: 0,
    });
    setRenderRenegociacaoTitulos(false);
    setOpenDialogRenegociacao(false);
    setCondicaoPagamento(null);
    setMeioPagamento(null);
    setRenegociacaoTitulos({});
    setPessoaId(null);
    setRecebedorList(listaPessoas);
    setListaContasPagar([]);
    retornoTopo();
  }

  const onDateChange = (date, fieldName) => {
    if (!date) {
      date = "Invalid Date";
    }
    const renegociacaoTemp = {
      ...renegociacaoTitulos,
      [fieldName]: date != "Invalid Date" ? formatDate.toSend(date) : null,
    };
    setRenegociacaoTitulos(renegociacaoTemp);
    calculaTotalAPagar(listaContasPagar, date);
  };

  const onChangeCondicao = (value) => {
    setRenegociacaoTitulos({
      ...renegociacaoTitulos,
      quantidadeParcelas: value?.parcelas,
    });
    setCondicaoPagamento(value);
  };

  const onChangeMeioPagamento = (value) => {
    const listaCondicoes = listaCondicoesPagamento.filter((condicao) =>
      condicao.meiosPagamentos.some((meio) => meio.id === value?.id),
    );
    setListaMeiosCondicao(listaCondicoes);
    setCondicaoPagamento(listaCondicoes[0]);
    setRenegociacaoTitulos({
      ...renegociacaoTitulos,
      quantidadeParcelas: listaCondicoes[0]?.parcelas,
    });
    setMeioPagamento(value);
  };

  return (
    <>
      {renderRenegociacaoTitulos && (
        <div
          className="p-3 position-fixed bottom-0 bg-white d-flex flex-row flex-wrap"
          style={{
            width: openCollapse ? "calc(100vw - 338px)" : "calc(100vw - 128px)",
            transition: "width 400ms ease",
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <Autocomplete
                id="meioPagamentoRenegociacao"
                name="meioPagamentoRenegociacao"
                required
                options={listaMeiosPagamento}
                autoHighlight
                getOptionLabel={(option) =>
                  option.descricao ? option.descricao : ""
                }
                noOptionsText="Sem opções"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Meio de Pagamento"
                    variant="outlined"
                    margin="normal"
                    required
                    error={inputErros.get("meioPagamentoRenegociacao")}
                  />
                )}
                onChange={(_, newValue) => onChangeMeioPagamento(newValue)}
                value={meioPagamento}
              />
            </Grid>
            <Grid item xs={3}>
              <Autocomplete
                required
                id="condicaoPagamentoRenegociacao"
                name="condicaoPagamentoRenegociacao"
                options={listaMeiosCondicao}
                autoHighlight
                getOptionLabel={(option) =>
                  option.descricao ? option.descricao : ""
                }
                getOptionSelected={(option, value) =>
                  option?.descricao === value?.descricao
                }
                disableClearable
                noOptionsText="Sem opções"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Condição de Pagamento"
                    variant="outlined"
                    margin="normal"
                    required
                    error={inputErros.get("condicaoPagamentoRenegociacao")}
                  />
                )}
                onChange={(_, newValue) => onChangeCondicao(newValue)}
                value={condicaoPagamento}
              />
            </Grid>
            <Grid item xs={3}>
              <DatePicker
                id="dataVencimento"
                name="dataVencimento"
                label="Data de Vencimento"
                format="dd/MM/yyyy"
                variant="outlined"
                margin
                required
                error={inputErro.indexOf("dataPagamento") != -1 ? true : false}
                fullWidth
                value={
                  renegociacaoTitulos?.dataVencimento
                    ? renegociacaoTitulos.dataVencimento
                    : null
                }
                onChange={(date) => onDateChange(date, "dataVencimento")}
              />
            </Grid>
            <Grid item xs={3}>
              <Button
                id="baixarTitulos"
                name="baixarTitulos"
                variant="contained"
                color="success"
                sx={{ p: "0.9rem", mt: "1rem" }}
                disabled={
                  !meioPagamento ||
                  !condicaoPagamento ||
                  !renegociacaoTitulos?.dataVencimento ||
                  totalAPagar?.pagar <= 0
                }
                onClick={handleOpenRenegociacao}
                fullWidth
              >
                <i
                  className="ph-fill ph-currency-dollar"
                  style={{ fontSize: 22, marginRight: 10, color: "white" }}
                ></i>
                Renegociar
              </Button>
            </Grid>
          </Grid>
          <RenegociacaoTitulosDialog
            openDialogRenegociacao={openDialogRenegociacao}
            setOpenDialogRenegociacao={setOpenDialogRenegociacao}
            listaRenegociacoes={listaRenegociacoes}
            setListaRenegociacoes={setListaRenegociacoes}
            handleSubmit={handleSubmit}
            sairRenegociacaoTitulos={sairRenegociacaoTitulos}
            listaMeiosPagamento={listaMeiosPagamento}
            recebedoresIguais={recebedoresIguais}
            recebedorList={recebedorList}
            pessoaId={pessoaId}
            setPessoaId={setPessoaId}
          />
          <ResumoTotalContas totalAPagar={totalAPagar} />
        </div>
      )}
    </>
  );
};

export default RenegociacaoTitulos;
